import React from 'react';
import { GridContainer, Column, Row, Box } from '@vp/swan';

import { useTranslations } from '@vp/om-translations';
import { useSelector } from 'react-redux';

import ContinueShopping from '../layout/layoutComponents/ContinueShopping';
import error01 from '../../../assets/images/error_01.svg';
import { cartSelectors } from '../../state/cart';
import { PendingItemSummaries } from './PendingItemSummariesDisplay';

/**
 * Assumes something is making the cart unavailable (ex: CTools is down). Displays message and continue shopping.
 */
export const CartUnavailableDisplay = () => {
  const [cartUnavailableMessages, cartMessages] = useTranslations([
    'cartUnavailableMessages',
    'cartMessages',
  ]);
  const pendingItemsCount = useSelector(state =>
    cartSelectors.selectPendingItemsCount(state.cart)
  );

  return (
    <GridContainer>
      <Row>
        <Column span={6}>
          <Box marginTop="5">
            <img src={error01} alt="error" />
          </Box>
          <Box marginTop="3" marginBottom="7">
            {cartUnavailableMessages.cartUnavailable}
          </Box>
          <Box visuallyHidden={pendingItemsCount === 0} marginBottom="7">
            {cartUnavailableMessages.existingWorkSaved}
          </Box>
          <Box>
            <PendingItemSummaries />
          </Box>
          <Row>
            <ContinueShopping buttonText={cartMessages.continueShopping} />
          </Row>
        </Column>
      </Row>
    </GridContainer>
  );
};
